import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import numeral from 'numeral';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(1),
    textAlign: 'center',
  },
  title: {
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightBold,
    paddingBottom: theme.spacing(1),
  },
  columns: {
    display: 'flex',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  label: {
    flexShrink: 0,
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
  },
  value: {
    flexGrow: 1,
  },
  editButton: {
    marginTop: theme.spacing(2),
  },
}));

const ExpensesTooltip = (props) => {
  const classes = useStyles();
  const {
    expenses, children,
  } = props;

  if (expenses.length === 0) {
    return (
      <Tooltip
        leaveDelay={200}
        interactive
        title={
          <div className={classes.content}>
            <Typography className={classes.title} variant="h6">
              {'No Monthly Expenses Found'}
            </Typography>
          </div>
      }
        placement="left-end"
        arrow
      >
        <div>{children}</div>
      </Tooltip>
    );
  }

  return (
    <Tooltip
      leaveDelay={200}
      interactive
      title={
        <div className={classes.content}>
          <Typography className={classes.title} variant="h6">
            {'Monthly Expenses'}
          </Typography>
          <div className={classes.columns}>
            <div className={classes.column}>
              {expenses.map(expense => (
                <div key={expense.attributes.name} className={classes.label}>
                  {expense.attributes.name}
                </div>
              ))}
            </div>
            <div className={classes.column}>
              {expenses.map(expense => (
                <div key={expense.attributes.name} className={classes.value}>
                  {`${numeral(expense.attributes.value).format('$0,0')}`}
                </div>
              ))}
            </div>
          </div>
        </div>
      }
      placement="left-end"
      arrow
    >
      <div>{children}</div>
    </Tooltip>
  );
};

ExpensesTooltip.propTypes = {
  expenses: PropTypes.array,
  children: PropTypes.node.isRequired,
};
ExpensesTooltip.defaultProps = {
  expenses: [],
};

export default ExpensesTooltip;
